export enum Languages {
  EN = 'en',
}
/**
 * IETF BCP 47语言标签是一种标准化代码，用于识别互联网上的人类语言标签结构已由互联网工程任务组（IETF）
 * 在最佳当前实践（BCP） 47中标准化；子标签由IANA语言子标签注册中心维护
 */
export enum Bcp47Locales {
  EN_SG = 'en-SG',
  EN_CA = 'en-CA',
  EN_US = 'en-US',
  EN_AU = 'en-AU',
  EN_GB = 'en-GB',
}
